import { createLucideIcon } from "lucide-react";

export const CreditCardNotFound = createLucideIcon(
    "CreditCardNotFound",
    [
        [
            "path",
            {
                d: "M2 2L22 22",
                key: "1tltpl",
            },
        ],
        [
            "path",
            {
                d: "M2.5 9H9",
                key: "1oh48f",
            },
        ],
        [
            "path",
            {
                d: "M21.5 9L13.5 9",
                key: "bo7th6",
            },
        ],
        [
            "path",
            {
                d: "M4.46334 4.5C4.145 4.62804 3.86325 4.78886 3.60746 4.99087C3.40678 5.14935 3.22119 5.32403 3.0528 5.5129C2 6.69377 2 8.46252 2 12C2 15.5375 2 17.3062 3.0528 18.4871C3.22119 18.676 3.40678 18.8506 3.60746 19.0091C4.86213 20 6.74142 20 10.5 20H13.5C16.4923 20 18.2568 20 19.5 19.5",
                key: "1wdooq",
            },
        ],
        [
            "path",
            {
                d: "M8 4.01578C8.7277 4 9.55437 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 14.3126 22 15.8693 21.7058 17",
                key: "1epmwn",
            },
        ],
    ],
);
